__turbopack_context__.v({
  "root": "tabs-module__xAhKwW__root",
});
